import styled from "styled-components";
import {Box, Heading} from "rebass";


export const PanelWrapper = styled(Box)`
  //overflow: hidden;
//z-index: 9210;

	//width: 400px;
  max-height: calc(50vh );
	  overflow-y: auto !important; /* [1] */
  -webkit-overflow-scrolling: touch !important; /* [4] */
  -ms-overflow-style: -ms-autohiding-scrollbar !important; /* [5] */
`

export const SectionHeading = styled(Heading)`
	font-size: 32px;
	font-weight: 900;
`


export const  Wrapper = styled(Box)`
	height: calc(100vh - 131px);
	//margin-bottom: 10px;
   overflow-x: auto; /* [1] */
  -webkit-overflow-scrolling: touch; /* [4] */
  -ms-overflow-style: -ms-autohiding-scrollbar; /* [5] */
  @media(max-width: 700px){
  	height: 70vh;

  }
`
// SectionHeading.defaultProps = {
//
// };